export const influencerOutlet = 'influencer';
